import * as React from "react"
import * as classNames from "./Banner.module.scss"
import Button from "../../../../common/blocks/button/Button"

import { Swiper, SwiperSlide } from "swiper/react"
import { Autoplay } from "swiper"
import "swiper/css"
import "swiper/css/autoplay"
import Card from "../../../../common/blocks/card/Card"

const Banner = ({ jobAds, isLeft }) => {
  return (
    <div className="job-ad-banner loadin">
      <Swiper
        type="annonce"
        breakpoints={{
          0: {
            width: 0,
            spaceBetween: 24,
            slidesPerView: 1,
          },
          320: {
            width: 320,
            spaceBetween: 24,
            slidesPerView: 1,
          },
          768: {
            width: 768,
            spaceBetween: 32,
            slidesPerView: 2.44,
          },
          1080: {
            width: 1080,
            spaceBetween: 48,
            slidesPerView: 2.44,
          },
          1440: {
            width: 1440,
            spaceBetween: 48,
            slidesPerView: 2.44,
          },
        }}
        freeMode={true}
        loop={true}
        autoplay={{
          delay: 1,
          reverseDirection: isLeft,
          disableOnInteraction: true,
        }}
        speed={10000}
        modules={[Autoplay]}
        wrapperClass="bottom pt-3 pb-6"
      >
        {jobAds?.map((jobAd, index) => (
          <SwiperSlide key={index}>
            <Card
              type="annonce"
              className={`flex flex-direction-column pbl-4 pin-4 ${classNames.cardBanner}`}
            >
              <div className={`flex ${classNames.cardHeader}`}>
                <div className="card__header__title mb-2">
                  <p className="fs-24">{jobAd.attributes.title}</p>
                </div>
              </div>
              <div className="card__content"></div>
              <div className="card__footer flex lg-align-items-center justify-content-space-between mt-auto flex-direction-column lg-flex-direction-row gap-2">
                <div className={classNames.tagsContainer}>
                  <div className="tags">
                    <Button
                      aspect="tag"
                      color="primary"
                      size="large"
                    >
                      {jobAd.attributes.agence.data?.attributes.city}
                    </Button>
                    {jobAd.attributes.criterias.data.map((critere, j) => {
                      if (critere.attributes.type === "Type_de_contrat") {
                        return (
                          <Button
                            key={j}
                            aspect="tag"
                            color="primary"
                            size="large"
                          >
                            {critere.attributes.value}
                          </Button>
                        )
                      } else {
                        return null
                      }
                    })}
                  </div>
                </div>
                <Button
                  aspect={"contrastant"}
                  color={"primary"}
                  size={"large"}
                  to={"/annonces/" + jobAd.attributes.slug}
                >
                  Postuler
                </Button>
              </div>
            </Card>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  )
}

export default Banner
